import {makeStyles} from "tss-react/mui";

export const useOrgPageStyles = makeStyles()((theme) => ({
  wrapper: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  contentWrapper: {
    overflowY: "auto",
    scrollbarWidth: "thin",
  },
  controls: {
    boxShadow: "-1px -1px 5px 1px rgba(0, 0, 0, 0.11)",
  },
  description: {
    borderBottom: "1px solid #cfcfcf",
  },
  subHeading: {
    fontSize: theme.spacing(3),
    fontWeight: "300",
  },
  switchWithInfoTooltip: {
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
  },
  memoryEntry: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid #cfcfcf",
    paddingTop: 8,
    paddingBottom: 8,
  },
}));
